<template>
    <div class="new-popupbox" @click="close()">
        <div class="hanlder-box">
            <svg class="icon-svg popup-close">
                <use xlink:href="#icon-guanbi" />
            </svg>
        </div>
        <div class="box-content" @click.stop>
            <div class="video-box" ref="dplayer" :src="videoUrl"></div>
        </div>
    </div>
</template> 

<script>
import Hls from 'hls.js';
import DPlayer from 'dplayer';

export default {
    props: {
        id: String
    },
    data() {
        return {
            loading: true,
            videoUrl: '',
        }
    },
    async mounted() {
        this.getMicroLesson();
    },
    methods: {
        async getMicroLesson() {
            const res = await this.$api.other.getMicroLesson(this.id);
            this.loading = false;

            if (res.code != 200) return this.$message.error(res.msg);;
            this.videoUrl = res.data.VideoUrl;
            this.setDplayer();
        },
        //设置播放器
        setDplayer() {
            new DPlayer({
                container: this.$refs.dplayer,
                autoplay: true, // 设置自动播放
                video: {
                    url: this.videoUrl,
                    type: 'customHls',
                    customType: {
                        customHls: function (video, player) {
                            const hls = new Hls();
                            hls.loadSource(video.src);
                            hls.attachMedia(video);
                        },
                    },
                },
            })
        },
        close() {
            this.$emit('close');
        }
    },
}
</script>

<style scoped lang="scss">
.new-popupbox {
    overflow-y: overlay;

    .box-content {
        width: 1100px;
        height: auto;

        .video-box {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            background-color: #333;
        }
    }

}
</style>